import React from "react"
import PropTypes from "prop-types"
import Layout from "../components/layout"
import Helmet from "react-helmet"
import Checkbox from "@material-ui/core/Checkbox"
import Button from "@material-ui/core/Button"
import { withStyles } from "@material-ui/core/styles"
import { CONSENTS } from "../components/gaprovider"

import style from "../components/privacy-legal.module.scss"

const BlueCheckbox = withStyles({
  root: {
    padding: "0px",
    color: "rgba(181,181,181,1)",
    transition: "color 0.15s",
    marginLeft: "-3px",
    marginBottom: "2px",
    marginRight: "4px",
    "&$checked": {
      color: "#1c7be4",
    },
    "&$disabled": {
      color: "#7eb3ef",
    },
    "&:hover": {
      backgroundColor: "transparent",
      color: "#7eb3ef",
    },
  },
  checked: {},
  disabled: {},
})(props => <Checkbox disableRipple={true} color="default" {...props} />)

const BlueButton = withStyles({
  root: {
    padding: "5px 10px",
    color: "#1c7be4",
    borderColor: "#1c7be4",
    transition: "color 0.15s",
    "&$disabled": {
      color: "#7eb3ef",
    },
    "&:hover": {
      backgroundColor: "#dfebf9",
    },
    "&:active": {
      backgroundColor: "#1c7be4",
      color: "white",
      borderColor: "white",
    },
  },
  disabled: {},
})(props => <Button disableRipple={true} {...props} />)

export default class PrivacyLegal extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.state = {}
    this.state[CONSENTS.ESSENTIAL] = !!this.context.consents[CONSENTS.ESSENTIAL]
    this.state[CONSENTS.FUNCTIONAL] = !!this.context.consents[
      CONSENTS.FUNCTIONAL
    ]
    this.state[CONSENTS.ANALYTICS_BASIC] = !!this.context.consents[
      CONSENTS.ANALYTICS_BASIC
    ]
  }

  componentDidMount() {
    const newConsents = {}
    newConsents[CONSENTS.ESSENTIAL] = true
    this.context.setConsents(newConsents)
  }

  render() {
    return (
      <Layout>
        <Helmet>
          <title>Privacy policy &amp; legal - Obicis</title>
          <meta
            name="description"
            content="Obicis values your privacy and protects your data. Read 
            more about our data policies and control your privacy settings."
          />
          <meta property="og:title" content="Privacy policy &amp; Legal" />
          <meta
            property="og:url"
            content="https://www.obicis.com/privacy-legal/"
          />
          <meta
            property="og:description"
            content="Obicis values your privacy and protects your data. Read 
            more about our data policies and control your privacy settings."
          />
        </Helmet>
        <div className={["main-layout", "content", style.layout].join(" ")}>
          <section>
            <h2>Our cookie policy</h2>
            Cookies are pieces of information that a visited website can persist
            in the browser of the visitor. They can be grouped by expiration
            (single session or persistent), visibility (visible only to the
            webserver or visible to the script of the web site running in the
            visitor's browser), security (available only over a secure protocol,
            i.e., HTTPS), and other criteria. An important distinction is
            whether they are the so-called first-party cookies or third-party
            cookies.
            <br />
            First-party cookies are the ones set and read by the visited
            website, in this case, obicis.com, and over which we have direct
            control. Third-party cookies are the ones set and read by other
            providers (third parties) whose services this site uses. Some
            examples include social connectors, third-party visitor analytics,
            third-party site abuse protection services, content delivery
            networks, etc. Those cookies are not accessible to this website, and
            we can not read them, set them, or delete them.
            <br />
            <br />
            <h3>Cookie settings</h3>
            At Obicis, we value and protect your privacy. Please review the
            following list of cookie groups this site uses and select the ones
            for which you give us your consent:
            <br />
            <div
              className={["cookie-checkbox", style.cookieCheckbox].join(" ")}
            >
              <BlueCheckbox disabled={true} checked={true} />
            </div>
            <div
              className={["cookie-description", style.cookieDescription].join(
                " "
              )}
            >
              <b>Essential cookies</b> - needed for this site to function
              correctly. Our first-party cookies include the cookie that{" "}
              <b>stores your cookie consent</b>
              .
              <br />
              They also include{" "}
              <b>third-party cookies set by our CDN, Cloudflare</b> (
              <a
                href="https://www.cloudflare.com/privacypolicy/"
                rel="noreferrer noopener"
                target="_blank"
              >
                Cloudflare Privacy Policy
              </a>
              ), required to deliver our site to you.
            </div>
            <br />
            <div
              className={["cookie-checkbox", style.cookieCheckbox].join(" ")}
            >
              <BlueCheckbox
                disabled={false}
                checked={this.state[CONSENTS.FUNCTIONAL]}
                onChange={() => {
                  this.setState(state => {
                    const newState = {}
                    newState[CONSENTS.FUNCTIONAL] = !state[CONSENTS.FUNCTIONAL]
                    return newState
                  })
                }}
              />
            </div>
            <div
              className={["cookie-description", style.cookieDescription].join(
                " "
              )}
            >
              <b>Functional cookies</b> - enable the functionality of some parts
              of this site. They include third-party cookies by Google for their{" "}
              <b>reCAPTCHA V2</b> service, which lets us protect the contact
              form from bots (
              <a
                href="https://www.google.com/policies/privacy/"
                rel="noreferrer noopener"
                target="_blank"
              >
                Google's privacy policy
              </a>{" "}
              and{" "}
              <a
                href="https://www.google.com/policies/terms/"
                rel="noreferrer noopener"
                target="_blank"
              >
                terms of use
              </a>
              ).
            </div>
            <br />
            <div
              className={["cookie-checkbox", style.cookieCheckbox].join(" ")}
            >
              <BlueCheckbox
                disabled={false}
                checked={this.state[CONSENTS.ANALYTICS_BASIC]}
                onChange={() => {
                  this.setState(state => {
                    const newState = {}
                    newState[CONSENTS.ANALYTICS_BASIC] = !state[
                      CONSENTS.ANALYTICS_BASIC
                    ]
                    return newState
                  })
                }}
              />
            </div>
            <div
              className={["cookie-description", style.cookieDescription].join(
                " "
              )}
            >
              <b>Analytics cookies</b> - these first-party cookies allow us to{" "}
              <b>recognize returning visitors</b> to our site. Since the cookie
              used to store the randomly generated identifier is a first-party
              cookie of obicis.com,{" "}
              <b>
                your activities on this site cannot be correlated with other web
                sites (or vice-versa)
              </b>
              , nor is it used for any cross-site tracking. Please review{" "}
              <a
                href="https://www.google.com/policies/privacy/"
                rel="noreferrer noopener"
                target="_blank"
              >
                Google's privacy policy
              </a>{" "}
              and{" "}
              <a
                href="https://www.google.com/policies/terms/"
                rel="noreferrer noopener"
                target="_blank"
              >
                terms of use
              </a>
              ) for more information on how Google protects your data.
            </div>
            <br />
            <br />
            <BlueButton
              variant="outlined"
              onClick={() => {
                const newConsents = {}
                newConsents[CONSENTS.FUNCTIONAL] = true
                newConsents[CONSENTS.ANALYTICS_BASIC] = true
                this.setState(newConsents)
                this.context.setConsents(newConsents)
              }}
            >
              Accept all
            </BlueButton>{" "}
            <BlueButton
              // variant="outlined"
              onClick={() => {
                const newConsents = {}
                newConsents[CONSENTS.FUNCTIONAL] = this.state[
                  CONSENTS.FUNCTIONAL
                ]
                newConsents[CONSENTS.ANALYTICS_BASIC] = this.state[
                  CONSENTS.ANALYTICS_BASIC
                ]
                this.context.setConsents(newConsents)
              }}
            >
              Save selection
            </BlueButton>
          </section>
          <section>
            <h2>Our personal data policy</h2>
            Obicis does not collect any personal data from visitors to this
            website, except for visitors who choose to contact us, using the
            provided contact form, email or any other method.
            <br />
            From those individuals, we collect their name, email address and
            optionally a contact number, along with any information they may
            choose to share with us. This information is stored exclusively for
            the purpose of replying to the received message and possibly to
            undertake the actions requested in their message if such exist.
            <br />
            This information is stored up to 6 months after the end of the
            conversation/relationship unless applicable laws or other legal
            reasons require otherwise.
            <br />
            <br />
            <h3>Your data rights</h3>
            <h4>The right to be informed</h4>
            Information on what we collect, from whom, how long we keep it and
            who we share it with. This has been described in detail in the
            previous paragraphs, a short summary is that we collect information
            only from the people who contact us, the information we collect is
            only the information necessary to reply to the queries, the
            information is shared only with the relevant employees of Obicis
            Ltd. for the purpose of replying to the message and the information
            will be retained for up to 6 months after the end of the
            conversation/relationship, unless required differently by the law.
            <h4>Right of access</h4>
            You have the right to find out if and what personal information we
            have about you. To exercise this right, send us a Subject access
            request (SAR) email or letter, or visit us in person.
            <h4>Right to rectification</h4>
            You have the right to correct the data we have about you. To do so,
            please use any of the usual communication means to let us know.
            <h4>Right to erasure</h4>
            You have the right to request that we delete your personal
            information. You can make this request using any usual form of
            communication. We will honor it unless a law requirement or a legal
            reason prohibits such action.
            <h4>Right to restrict processing</h4>
            In certain situations, you have the right to request that we not
            process your data.
            <h4>Right to data portability</h4>
            You have the right to ask for your data to be sent, either to you or
            another entity, in a commonly used and machine-readable format.
            <h4>Right to object</h4>
            In certain situations, you have the right to object to us processing
            your data.
            <br />
            <br />
            This collection of data rights is just an excerpt of the rights of
            our visitors based on the{" "}
            <a
              href="https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:02016R0679-20160504"
              rel="noreferrer noopener"
              target="_blank"
            >
              General Data Protection Regulation
            </a>{" "}
            of the European Union. For an exhaustive list of your rights and
            circumstances in which they apply, please consult the applicable
            laws.
          </section>
          <section>
            <h2>Legal information</h2>
            Obicis Ltd. For services, consulting and manufacture (short name:
            Obicis Ltd.) is registered with the Commercial Court of Zagreb as
            number 080923219. The share capital of the company is 20,000.00 kn,
            paid in full. The sole member of the board is Hrvoje Maračić. The
            IBAN of the business account is HR64 2484 0081 1070 1926 3, held
            with Raiffeisenbank Austria d.d., Zagreb, Magazinska cesta 69.
            <br />
            <br />
            Obicis d.o.o. za usluge, savjetovanje i proizvodnju (skraćeno:
            Obicis d.o.o.) je upisan u sudski registar Trgovačkog suda u Zagrebu
            pod brojem 080923219. Temeljni kapital društva iznosi 20.000,00 kn i
            uplaćen je u cijelosti. Jedini član uprave je Hrvoje Maračić. IBAN
            računa Društva je HR64 2484 0081 1070 1926 3, a vodi ga
            Raiffeisenbank Austria d.d., Zagreb, Magazinska cesta 69.
          </section>
        </div>
      </Layout>
    )
  }
}
PrivacyLegal.contextTypes = {
  setConsents: PropTypes.func,
  consents: PropTypes.object,
}
